import { get } from 'lodash';
import { init } from '../../context/AppCreateReferralProvider';
export default function buildDraftState(_ref) {
  var referral = _ref.referral,
    dispatchCreateReferral = _ref.dispatchCreateReferral;
  var person = get(referral, 'contact.id', '');
  var selectedPrograms = get(referral, 'referred_to_groups_draft').map(function (provider) {
    return {
      id: get(provider, 'program.id'),
      name: get(provider, 'program.name'),
      providerId: get(provider, 'id'),
      providerLicensed: get(provider, 'licensed'),
      providerName: get(provider, 'name'),
      receivingReferrals: get(provider, 'program.receiving_referrals'),
      service: get(referral, 'service.id'),
      // We need to pass the service like this because of the payload for the search app
      services: [get(referral, 'service.id')],
      status: get(provider, 'program.status')
    };
  });
  var draftState = {
    network: get(referral, 'referred_to_network', null),
    description: get(referral, 'description', null),
    attachments: get(referral, 'case.documents', null),
    // Get the first referral: 
    // https://github.com/unite-us/front-end/blob/master/packages/app-client/src/components/Cases/components/Detail/DraftCaseOptions.jsx#L53 
    id: get(referral, 'referrals[0].id', null),
    state: get(referral, 'referrals[0].state', null),
    case: {
      id: get(referral, 'referrals[0].case.id', null)
    }
  };
  return dispatchCreateReferral(init({
    selectedPrograms: selectedPrograms,
    person: person,
    draftState: draftState
  }));
}
;
//# sourceMappingURL=buildDraftState.js.map